import RaceStatus from './race_status_redux';

export default RaceStatus;
